;
!function () {
  try {
    var e = "undefined" != typeof window ? window : "undefined" != typeof global ? global : "undefined" != typeof globalThis ? globalThis : "undefined" != typeof self ? self : {};
    e._sentryModuleMetadata = e._sentryModuleMetadata || {}, e._sentryModuleMetadata[new e.Error().stack] = Object.assign({}, e._sentryModuleMetadata[new e.Error().stack], {
      "_sentryBundlerPluginAppKey:localcoin": true
    });
  } catch (e) {}
}();
import { useSyncExternalStore } from 'react';
const E2E_BYPASS_COOKIE_PREFIX = 'E2E_BYPASS=';

// The cookie is browser state rather than React state, and nothing in the app
// changes it while the page is open, so there is nothing to subscribe to.
const subscribe = () => () => {};
const getSnapshot = (): boolean => document.cookie.split(';').some(cookie => cookie.trim().startsWith(E2E_BYPASS_COOKIE_PREFIX));
const getServerSnapshot = (): boolean => false;
const useE2EBypass = () => {
  return useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
};
export default useE2EBypass;